/**
 * Espaciado vertical por bloque. El campo opcional `Espaciado` (component
 * `revisadas.espaciado`) define el padding interno top/bottom de un bloque con
 * tokens None/Quarter/Half/Full.
 *
 * Cada token resuelve al valor ABSOLUTO del registro homónimo del catálogo
 * `api::spacing.spacing` (Quarter/Half/Full), emitido como CSS var por
 * theme-config.js. None = 0. Si el tenant no tiene el registro, el token cae al
 * ritmo histórico de `--block-py` (ver globals.css).
 *
 * El hueco visible entre dos bloques = bottom del de arriba + top del de abajo.
 * El enum vive en Strapi; los valores GraphQL son None/Quarter/Half/Full.
 *
 * Si `Espaciado` viene vacío se devuelve `legacy` —la clase que el bloque ya
 * usaba—, así los tenants que no lo configuran renderizan idéntico.
 */
export interface TypeEspaciado {
  Top?: string | null;
  Bottom?: string | null;
}

const PADDING_TOP: Record<string, string> = {
  none: 'block-pt-none',
  quarter: 'block-pt-quarter',
  half: 'block-pt-half',
  full: 'block-pt-full',
};

const PADDING_BOTTOM: Record<string, string> = {
  none: 'block-pb-none',
  quarter: 'block-pb-quarter',
  half: 'block-pb-half',
  full: 'block-pb-full',
};

export const blockSpacing = (
  espaciado?: TypeEspaciado | null,
  legacy = 'block-padding',
): string => {
  if (!espaciado || (!espaciado.Top && !espaciado.Bottom)) return legacy;

  const top =
    PADDING_TOP[(espaciado.Top ?? 'Half').toLowerCase()] ?? PADDING_TOP.half;
  const bottom =
    PADDING_BOTTOM[(espaciado.Bottom ?? 'Half').toLowerCase()] ??
    PADDING_BOTTOM.half;

  return `${top} ${bottom}`;
};
